/* eslint-disable @typescript-eslint/no-require-imports */
import Ajax from '../../lib/Ajax';
import AxiosWrap from '../../lib/request';
import * as types from '../types/video-resource.type';
import { UPDATEOPERATIONSTATUS } from '../types/globalCreateSync.type';
import { message } from 'antd';
import Alert from '../../components/Alert/Alert';
import isNotRootLink from '../../util/isNotRootLink';
import _ from 'lodash';
import { VideoResourceType } from '../../pages/other-resource-list/types';
const qs = require('qs');
/**
 * 获取视频资源列表
 * @param  params 筛选条件
 */
export async function getVideoResourceList(params: any, cb: Function) {
  const _params = _.cloneDeep(params);

  let url = '';
  const analyzesData = await getSearchAnalyzes(_params.name);
  _params.page = _params.current - 1; // 页码从0开始
  if (_params.videoResourceTypeId === VideoResourceType.PREPARE_PPT) {
    url = '/temporary-resources/openschool-lessons';
  } else if (_params.videoResourceTypeId === VideoResourceType.PREPARE_RECORD) {
    url = '/temporary-resources/prepare-lesson-memoirs';
  } else {
    url = '/temporary-resources/prepare-lesson-packages';
  }

  if (url) {
    AxiosWrap({
      url,
      params: _params,
    })
      .then((res: any) => {
        const result = {
          page: {},
          list: [],
        };
        result.page = {
          ...res.data.page,
          number: res.data.page.number + 1,
        };
        const list = res.data._embedded?.lessons || res.data._embedded?.content || [];
        if (res.data._embedded) {
          result.list = cb ? cb(list, analyzesData) : list;
        } else {
          result.list = [];
        }
        (window as any)._dispatch({ type: types.GET_VIDEO_RESOURCE_LIST, payload: result });
        (window as any)._dispatch({ type: UPDATEOPERATIONSTATUS, payload: true });
      })
      .catch((err: any) => {
        (window as any)._dispatch({ type: UPDATEOPERATIONSTATUS, payload: true });
        (window as any)._dispatch({
          type: types.GET_VIDEO_RESOURCE_LIST,
          payload: {
            list: [],
            page: {
              size: params.size,
              number: params.current,
              totalPages: 0,
              totalElements: 0,
            },
          },
        });
        if (err && err.data) {
          if (err.status === 403) {
            (window as any).sessionStorage.setItem('fetchMenu', true);
            Alert.open(err.data.message, () => {
              isNotRootLink();
            });
          }
        }
      });
  }
}
/**
 * 获取关键词分词结果
 */
export function getSearchAnalyzes(text: string) {
  return AxiosWrap({
    url: `/global-search-analyzes?${qs.stringify({ text })}`,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err: any) => {
      err && err.data && message.error(err.data.message);
      return [];
    });
}
export function deleteCourse(id: number, success: () => void) {
  AxiosWrap({
    url: `/course/${id}`,
    method: 'DELETE',
  })
    .then((res: any) => {
      if (res.status === 200) success();
    })
    .catch((err: any) => err && err.data && message.error(err.data.message));
}
/**
 * 下架课程
 */
export function unReleaseCourse(params: number, success: () => void) {
  AxiosWrap({
    url: `/course/${params}/unRelease`,
    method: 'put',
  })
    .then((res: any) => {
      if (res.status === 200) success();
    })
    .catch((err: any) => err && err.data && message.error(err.data.message));
}
/**
 * 课程是否存在
 * @param id 课程id
 */
export async function existCourse(id: number) {
  try {
    const { status }: any = await Ajax({ url: `/course/${id}/check-exist` });
    if (status === 200) return Promise.resolve(true);
  } catch (error) {
    if (error) {
      if ((error as any).status === 404) {
        message.error('课程不存在！');
      } else if ((error as any).status === 403) {
        message.error('暂无权限！');
      }
    }
  }
}

/**
 * 课件预览
 * @param fileId 文件id
 * @param callback 文件不存在回调
 */
export async function filePreview(
  fileId: string,
  type: number,
  fileName: string,
  courseId: string,
  lessonId: string,
  resourceId: string,
  originalFileId: string,
  documentId: string,
) {
  try {
    // type=0 表示课件预览不参与统计埋点
    const {  data } = await AxiosWrap({
      url: `/files/${fileId}/preview?fileName=${fileName}&resourceId=${resourceId}&type=0`,
    });

     return data;
  } catch (error) {
    if (error && error.data) {
      message.error(error.data.message);
      if (error.status === 404) {
        // (window as any)._dispatch({ type: types.FILE_NO_EXIST, payload: true });
      }
    }
    return Promise.resolve({ fileId: '', url: '', marks: [] });
  }
}
